export default __webpack_public_path__ + "static/media/sightseeing.a820128c.svg";